import { render, staticRenderFns } from "./RoomLink.vue?vue&type=template&id=54dded1b&scoped=true&"
import script from "./RoomLink.vue?vue&type=script&lang=js&"
export * from "./RoomLink.vue?vue&type=script&lang=js&"
import style0 from "./RoomLink.vue?vue&type=style&index=0&id=54dded1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dded1b",
  null
  
)

export default component.exports